import { useEffect } from "react";

// language → code map
const languageCodes = {
  Arabic: "ar",
  Bengali: "bn",
  Czech: "cs",
  English: "en",
  French: "fr",
  Gujarati: "gu",
  Hindi: "hi",
  Hungarian: "hu",
  Pashto: "ps",
  Polish: "pl",
  Punjabi: "pa",
  Romanian: "ro",
  Russian: "ru",
  Slovak: "sk",
  Ukrainian: "uk",
  Urdu: "ur",
};

// code → language map
export const codeToLanguage = Object.entries(languageCodes).reduce(
  (acc, [name, code]) => {
    acc[code] = name;
    return acc;
  },
  {}
);

export const clearGoogleTranslateCookie = () => {
  const host = window.location.hostname;
  const expire = "Thu, 01 Jan 1970 00:00:00 GMT";
  // no-domain
  document.cookie = `googtrans=; expires=${expire}; path=/`;
  // host + dot-host
  [host, "." + host].forEach(
    (d) =>
      (document.cookie = `googtrans=; expires=${expire}; domain=${d}; path=/`)
  );
  window.googtrans = "/en/en"; // reset JS var
};

export const useGoogleTranslate = (visible = true) => {
  useEffect(() => {
    clearGoogleTranslateCookie();

    if (!visible) return;

    window.googleTranslateElementInit = () => {
      const el = document.getElementById("google_translate_element");
      if (!el || !window.google?.translate) return;
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: Object.values(languageCodes).join(","),
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,
        },
        "google_translate_element"
      );
    };

    if (!document.getElementById("google-translate-script")) {
      const s = document.createElement("script");
      s.id = "google-translate-script";
      s.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      s.async = true;
      document.body.appendChild(s);
    } else {
      window.googleTranslateElementInit();
    }

    // clear on print end and on unload
    window.onafterprint = clearGoogleTranslateCookie;
    window.onbeforeunload = clearGoogleTranslateCookie;

    return () => {
      clearGoogleTranslateCookie();
      delete window.googleTranslateElementInit;
      window.onafterprint = null;
      window.onbeforeunload = null;
      document.getElementById("google-translate-script")?.remove();
      document.getElementById("google_translate_element").innerHTML = "";
    };
  }, [visible]);
};
